import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { ChevronDown, ChevronUp } from 'react-feather';
import dayjs from 'dayjs';
import clsx from 'clsx';

import { Markdown } from 'app/seedly-component-library';

import {
  getCurrentCategory,
  getReviewPageProps,
} from 'app/selectors/productSelector';

const ReviewPageBanner = () => {
  const [isSummaryExpanded, setSummaryExpanded] = useState(false);
  const currentCategory = useSelector(getCurrentCategory);
  const { title, description } = useSelector(getReviewPageProps);

  const desktopBackground = get(currentCategory, 'desktopBackground', null);
  const mobileBackground = get(currentCategory, 'mobileBackground', null);
  const updatedAt = `Updated ${dayjs().format('MMMM')} ${dayjs().format(
    'YYYY',
  )}`;

  const faqs = currentCategory?.extra?.faqs;
  const showSummaryButton = faqs?.length > 0;

  return (
    <>
      <div className="jumbotron min-h-[264px] relative z-0">
        {/* Tailwind does not yet support dynamic background url so temp soln 
        is to have absolute imgs so we can hide/unhide based on viewport
        */}
        {desktopBackground && (
          <img
            src={desktopBackground}
            alt="banner"
            className="absolute w-full h-full inset-0 invisible lg:visible"
          />
        )}
        {mobileBackground && (
          <img
            src={mobileBackground}
            alt="banner"
            className="absolute w-full h-full inset-0 visible lg:invisible"
          />
        )}
        <div
          className={clsx(
            'flex flex-col items-center gap-2 max-w-5xl w-auto text-center p-4 z-10',
            showSummaryButton && 'mb-[45px]',
          )}
        >
          <h1
            data-testid="review-page-title"
            className="text-2xl font-bold text-neutral-100"
          >
            {title}
          </h1>
          <span
            data-testid="review-page-description"
            className="text-neutral-100 max-w-[640px]"
          >
            {description}
          </span>
          <span className="text-neutral-100">{updatedAt}</span>
        </div>
        {showSummaryButton && (
          <div
            className="flex items-center justify-center gap-1 absolute bottom-6 w-full my-0 mx-auto hover:cursor-pointer"
            onClick={() => {
              setSummaryExpanded(!isSummaryExpanded);
            }}
          >
            <p className="text-neutral-100">
              {isSummaryExpanded ? 'Hide' : 'Show'} Summary{' '}
            </p>
            {isSummaryExpanded ? (
              <ChevronUp size={20} className="text-neutral-100" />
            ) : (
              <ChevronDown size={20} className="text-neutral-100" />
            )}
          </div>
        )}
      </div>
      {isSummaryExpanded && (
        <div className="flex w-full py-6 px-4 bg-neutral-700 text-neutral-100">
          <div
            className={clsx(
              'columns-1 lg:columns-2 w-full gap-10 my-0 mx-auto',
              faqs.length === 1 && 'flex flex-col items-center justify-center ',
            )}
          >
            {faqs?.map(faq => {
              return (
                <div key={faq.id}>
                  <p className="text-sm font-bold text-neutral-100">
                    {faq.question}
                  </p>
                  <Markdown
                    source={faq.answer}
                    extendedClass="text-neutral-100"
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default ReviewPageBanner;
